
export default {
    sections: ['details'],
    // toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        from_url: {
            label: 'From URL',
            section: 'details',
            isRequired: true,
            position: 0,
        },

        to_url: {
            label: 'To URL',
            section: 'details',
            isRequired: true,
            position: 1,
        },

        is_regex: {
            label: 'Is URL a pattern?',
            cssClass: 'col-md-6 p-0',
            section: 'details',
            position: 2,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.redirect_url.js